// src/app/interceptors/http-logger.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { MixpanelService } from '../Services/mixpanel/mixpanel.service';


@Injectable()
export class HttpLoggerInterceptor implements HttpInterceptor {
    constructor(private mixpanel: MixpanelService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      timeout(10000), // ⏱ 10-second timeout
      catchError(error => {
        let errorType = '';
        let errorDetails: any = {
          url: req.url,
          method: req.method,
          time: new Date().toISOString()
        };

        if (error instanceof TimeoutError) {
          errorType = 'TimeoutError';
        } else if (error instanceof HttpErrorResponse) {
          if (error.status >= 400 && error.status < 500) {
            errorType = `ClientError ${error.status}`;
            errorDetails.status = error.status;
            errorDetails.message = error.message;
          }
        }

        if (errorType) {
        this.mixpanel.track('Checkout Error: ', {
            type: errorType,
            ...errorDetails
          });
        }

        return throwError(() => error);
      })
    );
  }
}
